import React from 'react'

import cross from "../../Assets/Icons/cross.svg";

import './QrCodePage.scss'
import {useLocation, useNavigate} from "react-router-dom";
import BaseButton from "../../Components/BaseButton/BaseButton";
import {useDispatch, useSelector} from "react-redux";
import QRCode from "react-qr-code";
import {setPanier, setTimeCreationPanier} from "../../store/actions";
import {StateModel} from "../../Models/StateModel";
import {DoorModel} from "../../Models/DoorModel";
import {useGoogleWallet} from "../../hooks/useGoogleWallet";
import {StadiumModel} from "../../Models/StadiumModel";
// import {EventModel} from "../../Models/EventModel";
// import {useFormatDate} from "../../hooks/useFormatDate";
import googleWalletBtn from '../../Assets/Images/google_wallet.svg'
import appleWalletBtn from '../../Assets/Images/apple-wallet.svg'
import {useModal} from "../../hooks/useModal";
import PlanModal from "../../Components/PlanModal/PlanModal";


declare global {
    interface Window {
        opera:any;
        MSStream:any;
    }
}
function getMobileOperatingSystem() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

const QrCodePage: React.FC = ({}) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const {state} = useLocation() as { state: { reference: string, pickup?: string, total: string, affluence: string } };

    const door = useSelector<StateModel, DoorModel | undefined>(state => state.door)
    const pdv = useSelector<StateModel, number | undefined>(state => state.selectedPdv)
    const stadium = useSelector<StateModel, StadiumModel | undefined>(state => state.stadium)
    // const event = useSelector<StateModel, EventModel | undefined>(state => state.event)
    const googleWalletUrl = useGoogleWallet(state.reference)
    const planModal = useModal()

    // const formatDate = useFormatDate()


    const handleClick = () => {
        dispatch(setPanier(undefined))
        dispatch(setTimeCreationPanier(undefined))
        if(door) {
            navigate(`/stands?stadium=${stadium?.reference}&doorId=${door.id}`)
        } else {
            navigate(`/menu?stadium=${stadium?.reference}&pdvId=${pdv}`)
        }
    }

    const formatPickup = () => {
        if(state.pickup) {
            const splited = state.pickup.split(" ")
            return splited[splited.length - 1]
        }
    }

    const formatAffluence = () => {
        if(state.affluence) {
            const splited = state.affluence.split("-")
            return splited[splited.length - 1]
        }
    }

    return (
            <div className="qrCode">
                {
                    state.pickup && (
                        <div className="qrCode__pickup">
                            <div className="qrCode__pickup--attache attacheLeft"/>
                            <div className="qrCode__pickup--attache attacheRight"/>
                            <p className="qrCode__pickup--title">PICK UP</p>
                            <p className="qrCode__pickup--number">{formatPickup()}</p>
                        </div>
                    )
                }
                <img className="qrCode--close" src={cross} onClick={handleClick} alt={"fermer"} />
                <div className="qrCode__imgContainer">
                    <QRCode value={state.reference} size={178} />
                </div>
                {
                    googleWalletUrl && getMobileOperatingSystem() === "Android" && (
                        <a href={googleWalletUrl} target="_blank" rel="noreferrer">
                            <img src={googleWalletBtn} className="qrCode--walletBtn" alt="google wallet"/>
                        </a>
                    )
                }
                {
                    getMobileOperatingSystem() === "iOS" && (
                        <a href={`${process.env.REACT_APP_BART_URL}/apple-wallet/${state.reference}`} target="_blank" rel="noreferrer">
                            <img src={appleWalletBtn} className="qrCode--walletBtn" alt="apple wallet"/>
                        </a>
                    )
                }
                <p className="qrCode--numero">Commande #{state.reference}</p>
                <p className="qrCode--prix">{state.total} €</p>
                { state.pickup && <p className="qrCode--porte">À retirer au <span>Pick up {formatPickup()}</span></p>}
                { state?.affluence && <p className="qrCode--hour">Commande prête dans <span>{formatAffluence()}</span> minutes</p>}
                {
                    stadium?.reference === "RGP" && (
                        <BaseButton text="Voir sur le plan" type="outline" onClick={planModal.open} className="qrCode--plan"/>
                    )
                }
                <div className="qrCode--btn">
                    <BaseButton onClick={handleClick} text="Retour au menu" type="outline" />
                </div>
                <PlanModal visible={planModal.visible} onClose={planModal.close} />
            </div>
    )
}

export default QrCodePage;
